export default __webpack_public_path__ + "static/3d-placeholder-44d66ccaff95f161e8e46563f071c01e.jpg";